export default __webpack_public_path__ + "static/media/find-substitute-active.1ba446c9.svg";